/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateUserProfileDto } from './createUserProfileDto';
import { CompanyRefDto } from './companyRefDto';


export interface CreateUserDto { 
    email: string;
    password?: string;
    firstName: string;
    lastName: string;
    /**
     * can be used as an alternative for email to login. If empty, email will be set.
     */
    username?: string;
    agency?: CompanyRefDto;
    status?: string;
    profile?: CreateUserProfileDto;
    sso?: boolean;
    salutation?: string;
    companyInfo?: string;
    expiryDate?: string;
    groups?: Array<string>;
    externalFlag?: boolean;
}

